import useSwr from 'swr'
import { API_URL } from '@/utils/constants'
import Wallet from '@/utils/wallet'

const fetcher = async (url: string) => {
	const res = await fetch(url)
	if (!res.ok) {
		throw new Error(`HTTP ${res.status} for ${url}`)
	}
	const data: unknown = await res.json()
	if (!Array.isArray(data)) {
		throw new Error('Invalid alkanes outpoints response')
	}
	return data
}

export default function useAlkanesOutpoints(
	alkanes_id: string,
	address?: string
): {
	data: any[]
	isLoading: boolean
	error: unknown
} {
	const addr = address || Wallet.getTaprootAddress()

	// A logged-out visitor has no address: `${undefined}` used to stringify
	// into the URL and fire /wallet/null/alkanes-outpoints/... → 400 on every
	// page load. No address (or no token) means no request at all.
	const { data, isLoading, error } = useSwr(
		addr && alkanes_id && alkanes_id !== 'undefined'
			? `${API_URL}/wallet/${addr}/alkanes-outpoints/${alkanes_id}`
			: null,
		fetcher
	)
	return { data: Array.isArray(data) ? data : [], isLoading, error }
}
